import { useParams } from "react-router";
import {
  isSupportedLanguageCode,
  type SupportedLanguageCode,
} from "../language";

const DEFAULT_LANG = "en";

/**
 * @returns The language code for the page based on the URL parameters.
 */
export function useLanguageCode(): SupportedLanguageCode {
  const { languageCode } = useParams();
  if (languageCode && isSupportedLanguageCode(languageCode)) {
    return languageCode;
  } else {
    // Fallback to English if the language code is not supported or provided.
    return DEFAULT_LANG as SupportedLanguageCode;
  }
}
